/**
 * Formats a duration in seconds into minutes using prime notation.
 *
 * - Below 1 minute: one decimal with a comma separator (Indonesian style) — `0,5'`.
 * - 1 minute or more: rounded whole minutes — `15'`.
 * - Returns `'-'` for non-positive input.
 *
 * @param totalSeconds - Number of seconds.
 * @returns Formatted minutes string, e.g. `0,5'` or `15'`.
 *
 * @example
 * formatSecondsToMinutes(30)    // "0,5'"
 * formatSecondsToMinutes(900)   // "15'"
 * formatSecondsToMinutes(0)     // "-"
 */
export function formatSecondsToMinutes(totalSeconds: number): string {
  if (totalSeconds <= 0) return '-'

  const minutes = totalSeconds / 60

  if (minutes < 1) {
    const rounded = Math.round(minutes * 10) / 10
    return `${rounded.toString().replace('.', ',')}'`
  }

  return `${Math.round(minutes)}'`
}
